import { MAIN_LAYOUT_PX } from '../../assets/constants/index.tsx';
import type { Theme } from '@mui/material';

export const buttonSx ={
  borderRadius: '50%',
  width: 480,
  height: 480,
}
export const wrapperSx = (theme:Theme) => ({
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  px: MAIN_LAYOUT_PX,
  background: theme.palette.bg,
})